// extracted by mini-css-extract-plugin
var _1 = "ControlBarContributorsButton-module__animateUploadProgressBarWidth--k1krh";
var _2 = "ControlBarContributorsButton-module__animatedBackground--ZrYfr";
var _3 = "ControlBarContributorsButton-module__button--Mfmck";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "button" }
